(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["isegrim-mp-get-t-with-s"]) return;
  try {
    
  const form = document.querySelector('#contact-form');
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const action = 'https://form.wombatcloud.com/form/pet_brand';
    if (grecaptcha.getResponse()) {
      submitForm(action, formData);
    } else {
      alert('Wypełnij captcha');
    }
  });

  function submitForm(action, formData) {
    fetch(action, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        formMessage('Dziękujemy za wysłanie formularza. Skontaktujemy się z Państwem wkrótce');
      })
      .catch((e) => {
        alert('Coś poszło nie tak. Spróbuj później lub zadzwoń do nas bezpośrednio.');
      });
  }

  function formMessage(text, bgColor = 'bg-main-brown') {
    const messageBox = document.querySelector('#form-message');
    if (!messageBox) return;
    messageBox.classList.add(bgColor);
    messageBox.classList.remove('hidden');
    messageBox.innerHTML = 'Dziękujemy za wysłanie formularza. Skontaktujemy się z Państwem wkrótce';
  }

  } catch(e) { console.error(e); }
})();
})();
